import { safeDefineFsComponent } from '@cof/safe-custom-element-define';
import { FsAlert as Alert } from './src/Alert.js';
const { customElementClass, safeTagName } = safeDefineFsComponent.define(Alert);
export const FsAlert = customElementClass;
export const tagName = safeTagName;
//# sourceMappingURL=fs-alert.js.map